import React, { useContext } from 'react';
import theme from '../theme/theme';
import { TextField, styled, useMediaQuery } from '@mui/material';
import { globalStore } from '../state/store';

const TextFieldScore = (props) => {

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const ScoreTextField = styled(TextField)({

      '& label.Mui-focused': {
        transform: 'translate(29px, -10px) scale(0.7)',
        fontWeight: '700',
      },
      '& .MuiInputLabel-root': {
        justifyContent: 'center',
        fontSize: '20px',
        transform: 'translate(32px, 34px) scale(1)',
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.primary.contrastText, //theme.palette.grey[100],
        borderRadius: isMdUp ? '40px' : isSmUp ? '35px' : '25px',
        padding: isMdUp ? '10px 20px 10px 20px' : isSmUp ? '5px 14px 5px 14px' : '2px 5px 2px 5px',
        width: isMdUp ? '110px' : isSmUp ? '70px' : '50px',
        fontSize: isMdUp ? '30px' : isSmUp ? '20px' : '15px',
        fontWeight: '900',
        color: theme.palette.grey[900],
        '& fieldset': {
          borderColor: theme.palette.grey[100],
        },
        '&:hover fieldset': {
          borderColor: theme.palette.grey[700],
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
      },
    });

    const [state] = useContext(globalStore);

    const { autoFocus, value, handlePredictionChange, type } = props

    
    const handleKeyDown = (e) => {

      // If tabbed on the away field when it has a value - block from focusing on the url bar
      if(type === "away" && e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault()
      }

    }


    const handleValueChange = (newVal) => {
      if((!isNaN(newVal) && newVal === '') || (parseInt(newVal) > -1 && parseInt(newVal) < 100)){
        handlePredictionChange(props.type, newVal === '' ? '' : parseInt(newVal))
      }
    }

    
    return (
        <ScoreTextField
        autoFocus={autoFocus}
        value={value}
        disabled={state.closedForEditing}
        //onFocus={type === "away" ? e => setIsFocused(true) : e => null}
        //onBlur={type === "away" ? e => setIsFocused(false) : e => null}
        //onFocus={e => type === "away" && setIsFocused(true)}
        //onBlur={e => type === "away" && setIsFocused(false)}
        onKeyDown={e => handleKeyDown(e)}
        onChange={e => handleValueChange(e.target.value)}
        //onBlur={e => handleValueChange(e.target.value)}
        InputProps={{ 
            inputProps: { 
                inputMode: 'numeric',
                style: { textAlign: "center" },
            },
            
        }}
        autoComplete="off"
        inputRef={props.inputRef}
        />
    );
};
export default TextFieldScore;